import React from "react";

const DigitalContractReportView = (props) =>{
    let { } = props

    // return(
    // )
}

export { DigitalContractReportView as default }